// Info/board/SwipeCardDeck.js
import React, { useMemo, useRef, useEffect, useState } from "react";
import TinderCard from "react-tinder-card";
import "./SwipeCardDeck.css";

const SwipeCardDeck = ({ 
  people, 
  currentIndex, 
  setCurrentIndex, 
  onSwipeDecision, 
  onUndoSwipe,
  isLargeScreen
}) => {

  const triggeredByButtonRef = useRef(false); // For bigger screen button logic
  const currentIndexRef = useRef(currentIndex);
  const childRefs = useMemo(
    () => Array(people.length).fill(0).map(() => React.createRef()),
    [people.length]
  );

  const updateCurrentIndex = (val) => {
    setCurrentIndex(val);
    currentIndexRef.current = val;
  };

  const swiped = (direction, person, index) => {
    onSwipeDecision?.(direction, person);
    updateCurrentIndex(index - 1);
  };

  const outOfFrame = (name, idx) => {
    console.log(`${name} left the screen`);
    if (currentIndexRef.current >= idx) {
      childRefs[idx].current.restoreCard();
    }
  };

  const canSwipe = currentIndex >= 0;
  const canGoBack = currentIndex < people.length - 1;

  const swipe = async (dir) => {
    if (canSwipe) {
      triggeredByButtonRef.current = true;
      await childRefs[currentIndex].current.swipe(dir);
    }
  };

  const goBack = async () => {
    if (!canGoBack) return;

    const newIndex = currentIndex + 1;
    updateCurrentIndex(newIndex);
    onUndoSwipe?.();
    await childRefs[newIndex].current.restoreCard();

  };

  return (
    <>
      {/*
      <div><p>{isLargeScreen ? 'isLargeScreen: no swipe' : 'not LargeScreen: can swipe'}</p></div>
      */}
      <div className="swipe-card-container">
        {people.map((person, index) => (
          <TinderCard
            ref={childRefs[index]}
            className={`swipe-outer ${isLargeScreen && 'is-large-screen'}`}
            key={person.name}
            onSwipe={(dir) => {
              if (!isLargeScreen || triggeredByButtonRef.current) {
                swiped(dir, person, index);
              }
            }}
            onCardLeftScreen={() => {
              if (!isLargeScreen || triggeredByButtonRef.current) {
                outOfFrame(person.name, index);
              }
            }}
            preventSwipe={isLargeScreen ? ["up", "down", "left", "right"] : ["up", "down"]}
          >
            <div
              className="swipe-card"
              style={{ backgroundImage: `url(${person.img})` }}
            >
              <h3>{person.name}</h3>
            </div>
          </TinderCard>
        ))}

        {/* Button Controls */}
        <div className="swipe-buttons">
          <button onClick={() => swipe("left")} disabled={!canSwipe}>👎</button>
          <button onClick={goBack} disabled={!canGoBack}>↩️</button>
          <button onClick={() => swipe("right")} disabled={!canSwipe}>👍</button>
        </div>
      </div>
    </>
  );
};

export default SwipeCardDeck;
